import { FC, useState } from 'react'
import cn from 'classnames'

import { IMessage } from '@/context/types'
import { DateTime } from 'luxon'

import { getAvatarText, removeWhitespaces } from './utils'
import { AUTHOR_TYPES } from '@/context/constants'

interface Props {
  message: IMessage
}

const Message: FC<Props> = ({ message }) => {
  const [open, setOpen] = useState(false)

  const displayMessage = (messageText: string) => {
    const ROWS = 5
    let showMessage = messageText
    const showLess = !open
    const splitMessage = messageText.split('\n')

    if (splitMessage.length > ROWS && showLess) {
      showMessage = splitMessage.slice(0, ROWS + 1).join('\n')
    }

    return (
      <>
        {removeWhitespaces(showMessage)}
        {splitMessage.length > ROWS && (
          <div>
            {!open && <div className="pmui-text-base">...</div>}
            <div className="pmui-mt-3">
              <span
                className="pmui-cursor-pointer pmui-text-xs pmui-font-semibold pmui-underline"
                onClick={() => {
                  setOpen(prev => !prev)
                }}
              >
                {open ? 'Show less' : 'Show more'}
              </span>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <div className="pmui-mb-8 pmui-text-xs">
      <div className="pmui-flex">
        <div
          className={cn(
            'pmui-inline-flex pmui-justify-center pmui-items-center \
             pmui-overflow-hidden \
             md:pmui-w-10 md:pmui-h-10 md:pmui-mr-3 \
             pmui-w-8 pmui-h-8 pmui-mr-2 \
             pmui-rounded-full',
            {
              'pmui-bg-purpleLighter':
                message.author.type === AUTHOR_TYPES.USER,
            },
            {
              'pmui-bg-gray-600': message.author.type === AUTHOR_TYPES.BUSINESS,
            },
          )}
        >
          <span className="sm:pmui-text-sm md:pmui-text-base pmui-text-white">
            {getAvatarText(message)}
          </span>
        </div>
        <div className="pmui-flex-1">
          <div className="pmui-font-semibold sm:pmui-text-sm md:pmui-text-base">
            {message.author.displayName || 'Poplar Homes'}
          </div>
          <div className="pmui-flex pmui-items-end ">
            <div className="pmui-flex-1 pmui-text-pop-gray-200  sm:pmui-text-xs md:pmui-text-sm">
              {message.author.type === AUTHOR_TYPES.BUSINESS
                ? 'Maintenance Operations Rep'
                : 'Owner'}
            </div>
            <div className="sm:pmui-text-xs md:pmui-text-sm">
              {DateTime.fromISO(message.received).toRelative()}{' '}
              {DateTime.fromISO(message.received).toFormat('hh:mma')}
            </div>
          </div>
        </div>
      </div>
      <div
        className={cn(
          'pmui-mt-4 pmui-p-4 pmui-rounded-b-2xl pmui-rounded-r-2xl',
          {
            'pmui-text-white pmui-bg-[#5db5f0]':
              message.author.type === AUTHOR_TYPES.USER,
          },
          {
            'pmui-text-[#383F4A] pmui-bg-[#f7f7f7]':
              message.author.type === AUTHOR_TYPES.BUSINESS,
          },
        )}
      >
        <pre className="sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03 pmui-whitespace-pre-wrap">
          {displayMessage(message.content.text)}
        </pre>
      </div>
    </div>
  )
}

export default Message
